import { useCallback, useEffect, useState } from "react";
import type { WordListStatus } from "@/components/tools/word-games/use-word-list";
import {
  loadSpoonerIndex,
  type SpoonerIndex,
} from "@/lib/tool-kit/word-games/spoonerism";

/**
 * The pronunciation dictionary and word list the Spoonerism Generator needs, fetched
 * once per page load. Nothing is requested until `wanted` turns true.
 */
export function useSpoonerIndex(wanted: boolean) {
  const [index, setIndex] = useState<SpoonerIndex | null>(null);
  const [status, setStatus] = useState<WordListStatus>("idle");

  useEffect(() => {
    if (!wanted || status !== "idle") {
      return;
    }
    setStatus("loading");
    loadSpoonerIndex()
      .then((loaded) => {
        setIndex(loaded);
        setStatus("ready");
      })
      .catch(() => setStatus("error"));
  }, [wanted, status]);

  const retry = useCallback(() => setStatus("idle"), []);
  return { index, status, retry };
}
